import { IntlProvider } from 'react-intl';
import { Outlet } from 'react-router-dom';
import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import NotificationsContainer from '@rio-cloud/rio-uikit/NotificationsContainer';

import { DEFAULT_LOCALE } from 'src/configuration/lang/lang';
import { useAppDispatch, useAppSelector } from 'src/configuration/setup/hooks';
import { getDisplayMessages, getLocale } from 'src/configuration/lang/langSlice';
import DefaultRedirect from 'src/routes/DefaultRedirect';
import RouteUpdater from 'src/routes/RouteUpdater';
import { SessionExpiredDialog } from '@rio-cloud/rio-session-expired-info';
import { isUserSessionExpired } from 'src/configuration/login/loginSlice';
import { getSessionExpiredAcknowledged, hideSessionExpiredDialog } from 'src/data/appSlice';
import AppHeader from 'src/features/header/AppHeader';

import './App.css';
import 'flag-icons/css/flag-icons.min.css';
import { useRef } from 'react';
import { AppContext } from './AppContext';
import { useGetProtectedQuery } from 'src/services/authApi';

const AppLayout = () => {
    const dispatch = useAppDispatch();
    const sidebarRef = useRef();
    const userLocale = useAppSelector(getLocale);
    const displayMessages = useAppSelector(getDisplayMessages);
    const isSessionExpired = useAppSelector(isUserSessionExpired);
    const sessionExpiredAcknowledged = useAppSelector(getSessionExpiredAcknowledged);

    useGetProtectedQuery({});

    if (!(displayMessages && userLocale)) {
        return null;
    }
    const handleSessionExpiredDialogClose = () => dispatch(hideSessionExpiredDialog);
    const showSessionExpired = isSessionExpired && !sessionExpiredAcknowledged;
    return (
        <IntlProvider defaultLocale={DEFAULT_LOCALE} key={userLocale} locale={userLocale} messages={displayMessages}>
            <AppContext.Provider value={{ sidebarRef }}>
                <ApplicationLayout data-testid={'app-layout'}>
                    <ApplicationLayout.Header>
                        <AppHeader />
                    </ApplicationLayout.Header>
                    <ApplicationLayout.Sidebar className='right' ref={sidebarRef} />
                    <ApplicationLayout.Body>
                        <NotificationsContainer />
                        <SessionExpiredDialog
                            locale={userLocale}
                            onClose={handleSessionExpiredDialogClose}
                            show={showSessionExpired}
                        />
                        <Outlet />
                        <RouteUpdater />
                        <DefaultRedirect />
                    </ApplicationLayout.Body>
                </ApplicationLayout>
            </AppContext.Provider>
        </IntlProvider>
    );
};

export default AppLayout;
